import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=057b63ef&lang=less&scoped=true"

import exportComponent from "E:\\Workspaces\\成品油\\成品油_基础版\\成品油溯源码（扫码）\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057b63ef"]])

export default __exports__